module.exports = __webpack_public_path__ + "img/millfields_rd.b50dd58e.jpg";